<script lang="ts">
    import { Route, Router } from 'yrv'
    import Ztab from '../../_common/z/ztab.svelte'
    import ResourcesLockEntries from './resources-lock-entries.svelte'

    let tabs = [
        {
            title: 'Salas e Equipamentos',
            url: '/resources-lock/entries',
        },
    ]
</script>

<div class="limit-1600 p-2">
    <Ztab class="" {tabs} />
    <Router>
        <Route path="/entries">
            <ResourcesLockEntries />
        </Route>
    </Router>
    <div class="m-bottom-sm" />
</div>
